import Vue from 'vue';
import Router from 'vue-router';
import routers from './systemRouters.js';
import dialog from '@/components/Dialog';
import { getToken } from '@/utils';
import { getObjectFromLocalStorage, setObjectToSessionStorage } from '@/utils';
import store from '@/store'
import { nextTick } from 'process';
Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: routers
});

const originalPush = Router.prototype.push;
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(e => {});
}

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function push (location, onComplete, onAbort) {
  return originalReplace.call(this, location, onComplete, onAbort).catch(e => {});
}

/**
 * 路由跳转的时候判断token是否存在
 */

router.beforeResolve((to, from, next) => {
  if (to.name === 'login' || to.name === 'privacy') {
    next();
  } else {
    let token = getToken();
    if (!token || !/\S/.test(token)) {
      dialog.closeAll();
      next({ name: 'login' })
    } else {
      /*
        网址复制新页面路由切换问题修改
         change wang 
         date 2023.4.24
       */
      if (from.path !== location.href.split('?')[0].split('#')[1]) {
        let formId = null
        let menuId = null
        let formName = null
        if (location.href.split('?').length > 1) {
          const arr = location.href.split('?')[1].split('&')
          arr.forEach(item => {
            const pathName = item.split('=')
            if (pathName[0] === 'formId') {
              formId = pathName[1]
            }
          })
        } else {
          const arr = location.href.split('#')[1].split('/')
          formName = arr[arr.length - 1]
        }
        if (formId || formName) {
          getObjectFromLocalStorage('menuList', []).forEach(item => {
            if (formId && item.onlineFormId === formId) {
              menuId = item.menuId
            }
            if (formName && item.formRouterName === formName) {
              menuId = item.menuId
            }
          })
            setObjectToSessionStorage('currentColumnId', menuId)
            setObjectToSessionStorage('currentMenuId', menuId)
            store.commit('setCurrentMenuId', menuId)
       }
      }
      next();
    }
  }
});

export default router;
